import styled from 'styled-components';
import { Layout } from 'antd';

const { Header } = Layout;

export const HeaderWrapper = styled(Header)`
  padding: 0 30px;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
